import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
import { ShieldCheck, Download } from 'lucide-react';
export function OfferSection() {
  return <div id="offer" className="bg-[#FAF6F0] py-20" data-id="element-75">
      <Section data-id="element-76">
        <div className="max-w-3xl mx-auto bg-white rounded-3xl shadow-xl overflow-hidden border border-[#D4A89A]/30" data-id="element-77">
          <div className="bg-[#3D2B1F] text-[#FAF6F0] p-8 text-center" data-id="element-78">
            <h2 className="text-3xl md:text-4xl font-bold mb-2" data-id="element-79">
              El Plan 21 Días
            </h2>
            <p className="text-[#D4A89A] font-serif text-2xl italic" data-id="element-80">
              "Casa Silenciosa"
            </p>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-81">
            <div className="mb-8" data-id="element-82">
              <span className="text-gray-500 text-lg line-through block mb-2" data-id="element-83">
                $29 USD
              </span>
              <div className="text-6xl font-bold text-[#B8845C] font-serif" data-id="element-84">
                $6.39
              </div>
              <p className="text-[#3D2B1F]/70 mt-4" data-id="element-85">
                PDF Digital + Cuaderno de trabajo imprimible
              </p>
            </div>

            <Button size="lg" href="https://www.ritualesserenos.com/cart/47403464950009:1" className="w-full md:w-auto text-xl px-12 py-8 mb-6 shadow-xl shadow-[#B8845C]/20 animate-pulse" data-id="element-86">
              Descargar Ahora
            </Button>

            <div className="flex items-center justify-center gap-2 text-sm text-[#3D2B1F]/60 mb-8" data-id="element-87">
              <Download size={16} data-id="element-88" />
              <span data-id="element-89">
                Acceso inmediato. Lectura en teléfono, tablet o papel.
              </span>
            </div>

            <div className="bg-[#FAF6F0] p-6 rounded-xl border border-[#D4A89A]/20 text-left" data-id="element-90">
              <div className="flex items-start gap-4" data-id="element-91">
                <ShieldCheck className="w-8 h-8 text-[#B8845C] shrink-0" data-id="element-92" />
                <div data-id="element-93">
                  <h4 className="font-bold text-[#3D2B1F] mb-2" data-id="element-94">
                    Garantía (simple y digna)
                  </h4>
                  <p className="text-[#3D2B1F]/80 text-sm leading-relaxed" data-id="element-95">
                    Si después de{' '}
                    <strong className="text-[#B8845C]" data-id="element-96">7 días</strong> sientes
                    que este plan no te dio nada de estructura o alivio práctico
                    en tus horas difíciles, pide reembolso. (La idea es que lo
                    pruebes de verdad, sin miedo.)
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-20 text-center max-w-2xl mx-auto" data-id="element-97">
          <h3 className="text-2xl font-serif font-bold text-[#3D2B1F] mb-6" data-id="element-98">
            Pregunta final (la que importa)
          </h3>
          <p className="text-xl text-[#3D2B1F]/80 mb-8 leading-relaxed" data-id="element-99">
            Si hoy la tarde te está ganando… ¿qué pasaría si, por 21 días, tú no
            te abandonas?
          </p>
          <div className="inline-block relative" data-id="element-100">
            <strong className="text-3xl md:text-4xl text-[#B8845C] font-serif block mb-2" data-id="element-101">
              Empieza hoy.
            </strong>
            <div className="h-3 bg-[#D4A89A]/30 w-full absolute bottom-2 -z-10 rotate-1" data-id="element-102"></div>
          </div>
          <p className="text-xl text-[#3D2B1F]/60 mt-4 italic" data-id="element-103">
            Porque mañana a la tarde… vuelve a llegar.
          </p>
        </div>
      </Section>
    </div>;
}